document.addEventListener("DOMContentLoaded", function(event) {

  // setTimeout(function(){
  //   const sizeInputs = document.querySelectorAll('[data-option-name="Size"] input');
  //   const onLoadVariant = 'Medium';
    
  //   for (const sizeInput of sizeInputs) {
  //     var onLoadVariantVal = sizeInput.value;
      
  //     if (onLoadVariant.match(onLoadVariantVal)) {
  //       console.log(sizeInput.nextElementSibling.classList);
  //       if(sizeInput.nextElementSibling.classList.contains('is-disabled')) {
  //        console.log("medium out of stock")
  //       } else {
  //         console.log("medium in stock")
  //         sizeInput.nextElementSibling.click();
  //       }
  //     }
  //   }
  // }, 400);

  let urlOptionParams = new URLSearchParams(window.location.search);
  let selectedSize = urlOptionParams.get('Size');
  let selectedColor = urlOptionParams.get('Color');
  if (selectedSize && selectedColor) {
    document.querySelectorAll('[data-block-type="product-siblings"] a').forEach(link => {
      var current = link.href.split('?')[0];
      var varId = link.getAttribute('data-size-color-' + selectedSize + '-' + selectedColor);
      link.href = current + '?variant=' + varId + '&Size=' + selectedSize + '&Color=' + selectedColor;
    });
  } 
  

  function getPrevSiblingBlock(element) {
  while ((element = element.previousSibling)) {
      if (element.style.display === '' && !element.hasAttribute('hidden')) {
        return element;
      }
    }
    return null;
  }

  function getNextSiblingBlock(element) {
  while ((element = element.nextSibling)) {
      if (element.style.display === '' && !element.hasAttribute('hidden')) {
        return element;
      }
    }
    return null;
  }

  const thumbnailMobileControlNext = document.getElementById('thumbnail-mobile-control-next');
  if (thumbnailMobileControlNext !== null) {
    thumbnailMobileControlNext.addEventListener('click', function() {
      const element = document.querySelector('product-gallery-navigation button[aria-current="true"]');
      const nextSibling = getNextSiblingBlock(element);
      
      if (nextSibling) {
        let mediaId = nextSibling.getAttribute('data-media-id');
        if (mediaId !== null) {
          document.querySelector('button[data-media-id="'+ mediaId +'"]').click();
        }
      }
    });
  }

  const thumbnailMobileControlPrev = document.getElementById('thumbnail-mobile-control-prev');
  if (thumbnailMobileControlPrev !== null) {
    thumbnailMobileControlPrev.addEventListener('click', function() {
      const element = document.querySelector('product-gallery-navigation button[aria-current="true"]');
      const nextSibling = getPrevSiblingBlock(element);
      
      if (nextSibling) {
        let mediaId = nextSibling.getAttribute('data-media-id');
        if (mediaId !== null) {
          document.querySelector('button[data-media-id="'+ mediaId +'"]').click();
        }
      }
    });
  }

  let carouselContainer = document.querySelector('.product-gallery .product-gallery__carousel');
  if (carouselContainer !== null) {
    let carouselContainerHeight = carouselContainer.clientHeight;
    document.querySelector('.product-gallery .product-gallery__thumbnail-scroller').style.maxHeight = carouselContainerHeight + 'px';
  }
  

  let readMoreToggle = document.querySelector('.read-more .read-more-toggle');
  let readMoreText = document.querySelector('.read-more .read-more-text');

  if (readMoreToggle !== null) {
    readMoreToggle.addEventListener('click', function() {
      if (readMoreText.style.display === "none") {
        readMoreText.style.display = "block";
        readMoreToggle.innerText = "Read Less";
      } else {
        readMoreText.style.display = "none";
        readMoreToggle.innerText = "Read More";
      }
    }, false);
  }

  var colorSwatch = document.querySelectorAll('variant-picker label.color-swatch');

  for (var i = 0; i < colorSwatch.length; i++) {
    colorSwatch[i].addEventListener('click', function(event) {
      setTimeout(function(){
        const elements = document.querySelectorAll(".product-gallery__thumbnail");
        var elementsArray = Array.from(elements);
        
        // Filter out elements with the hidden attribute
        const visibleElements = elementsArray.filter(element => element.hidden);
        
        // Do something with the visible elements
        visibleElements.forEach(element => {
          element.setAttribute('aria-current', 'false')
        });
      }, 200);
      
    });
  }

  const productCardShowMoreButtons = document.querySelectorAll('.product-card .product-card__colors .show-more');
  
  if (productCardShowMoreButtons) {
      productCardShowMoreButtons.forEach(productCardShowMoreButton => {
      productCardShowMoreButton.addEventListener('click', function() {
        this.remove();
      });
    });
  }

  const productCardColors = document.querySelectorAll('.product-card .product-card__colors label');
  
  if (productCardColors) {
      productCardColors.forEach(productCardColor => {
      productCardColor.addEventListener('click', function() {
        let quickViewColor = this.getAttribute('on-click');
        let quickViewColorName = this.querySelector('span').innerText;
        document.querySelector('[for="' + quickViewColor + '"]').click();
        let quickViewProductCard = this.closest('.product-card');
        quickViewProductCard.querySelector('.product-card__quick-view--mobile-color').innerText = quickViewColorName;
        let unselectedFieldset = quickViewProductCard.querySelector('fieldset[unselected-option]');
        if (unselectedFieldset) {
          unselectedFieldset.removeAttribute('unselected-option');
        }
      });
    });
  }

  const productCardSizes = document.querySelectorAll('.product-card__quick-view [data-option-name="Size"] label, .product-card__quick-view [data-option-name="Options"] label, .product-card__quick-view [data-option-name="Value"] label');
  
    if (productCardSizes) {
        productCardSizes.forEach(productCardSize => {
        productCardSize.addEventListener('click', function() {
          let quickViewContainer = this.closest('.product-card__quick-view');
          setTimeout(function(){
            let variant_id = quickViewContainer.querySelector('input[name="id"]').value;
            // console.log(variant_id);
            var data = {
              "id": variant_id,
              "quantity": 1
            }
            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: data,
              dataType: 'json',
              success: function() { 
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true,  //this code is for prestige theme, is to refresh the cart
                  detail: {
                    quantity: 1
                  }
                }));
                document.querySelector('[aria-controls="cart-drawer"]').click();
              }   
            }); 
          }, 50);
          document.querySelectorAll('.product-card__quick-view').forEach(function (elem) {
            elem.classList.remove('active');
          });
          document.querySelectorAll('.product-card__quick-view .variant-picker').forEach(function (elem) {
            elem.classList.remove('active');
          });
          document.documentElement.classList.remove('lock');
        });
      });
    }

  const productCardQuickDesktopButtons = document.querySelectorAll('.product-card__quick-view .product-card__quick-view--add-desktop');

  if (productCardQuickDesktopButtons) {
      productCardQuickDesktopButtons.forEach(productCardQuickDesktopButton => {
      productCardQuickDesktopButton.addEventListener('click', function() {
        let quickViewContainer = this.closest('.product-card__quick-view');
        document.querySelectorAll('.product-card__quick-view .variant-picker').forEach(function (elem) {
          elem.classList.remove('active');
        });
        quickViewContainer.querySelector('.variant-picker').classList.add('active');
      });
    });
  }

  const productCardQuickMobileButtons = document.querySelectorAll('.product-card__quick-view--add-mobile');

  if (productCardQuickMobileButtons) {
      productCardQuickMobileButtons.forEach(productCardQuickMobileButton => {
      productCardQuickMobileButton.addEventListener('click', function() {
        let quickViewProductCard = this.closest('.product-card');
        document.querySelectorAll('.product-card__quick-view').forEach(function (elem) {
          elem.classList.remove('active');
        });
        quickViewProductCard.querySelector('.product-card__quick-view').classList.add('active');
        document.documentElement.classList.add('lock');
      });
    });
  }

  const productCardQuickOverlays = document.querySelectorAll('.product-card__quick-view-overlay');

  if (productCardQuickOverlays) {
      productCardQuickOverlays.forEach(productCardQuickOverlay => {
      productCardQuickOverlay.addEventListener('click', function() {
        let quickViewProductCard = this.closest('.product-card');
        quickViewProductCard.querySelector('.product-card__quick-view').classList.remove('active');
        document.documentElement.classList.remove('lock');
      });
    });
  }

  const productCardQuickCloseButtons = document.querySelectorAll('.product-card__quick-view__close-button');

  if (productCardQuickCloseButtons) {
      productCardQuickCloseButtons.forEach(productCardQuickCloseButton => {
      productCardQuickCloseButton.addEventListener('click', function() {
        let quickViewProductCard = this.closest('.product-card');
        quickViewProductCard.querySelector('.product-card__quick-view').classList.remove('active');
        document.documentElement.classList.remove('lock');
      });
    });
  }

  const urlParams = new URLSearchParams(window.location.search);
  const campaignIdFromUrl = urlParams.get('BFCM25_holidaysavings');
  console.log(urlParams);

  if (campaignIdFromUrl == 'ALL') {
    let campaignMessages = document.querySelectorAll(".BFCM25_holidaysavings");
    let campaignPrices = document.querySelectorAll(".BFCM25_holidaypricing");

    if (campaignMessages) {
      campaignMessages.forEach(campaignMessage => {
        campaignMessage.style.display = 'block';
      });
    }
    if (campaignPrices) {
      campaignPrices.forEach(campaignPrice => {
        campaignPrice.style.display = 'block';
      });
    }

    localStorage.setItem('BFCM25_holidaysavings', campaignIdFromUrl);

    const attributeName = "BFCM25_holidaysavings";
    const attributeValue = "ALL";

    const formData = new FormData();
    formData.append(`attributes[${attributeName}]`, attributeValue);

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      console.log('Cart updated successfully:', data);
    })
    .catch(error => {
      console.error('Error updating cart:', error);
    });

    setTimeout(function() {
      let campaignMessages = document.querySelectorAll(".BFCM25_holidaysavings");
      let campaignPrices = document.querySelectorAll(".BFCM25_holidaypricing");

      if (campaignMessages) {
        campaignMessages.forEach(campaignMessage => {
          campaignMessage.style.display = 'block';
        });
      }
      if (campaignPrices) {
        campaignPrices.forEach(campaignPrice => {
          campaignPrice.style.display = 'block';
        });
      }

      localStorage.setItem('BFCM25_holidaysavings', campaignIdFromUrl);

      const attributeName = "BFCM25_holidaysavings";
      const attributeValue = "ALL";

      const formData = new FormData();
      formData.append(`attributes[${attributeName}]`, attributeValue);

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        console.log('Cart updated successfully:', data);
      })
      .catch(error => {
        console.error('Error updating cart:', error);
      });
    }, 1000);

    setTimeout(function() {
      let campaignMessages = document.querySelectorAll(".BFCM25_holidaysavings");
      let campaignPrices = document.querySelectorAll(".BFCM25_holidaypricing");

      if (campaignMessages) {
        campaignMessages.forEach(campaignMessage => {
          campaignMessage.style.display = 'block';
        });
      }
      if (campaignPrices) {
        campaignPrices.forEach(campaignPrice => {
          campaignPrice.style.display = 'block';
        });
      }

      localStorage.setItem('BFCM25_holidaysavings', campaignIdFromUrl);

      const attributeName = "BFCM25_holidaysavings";
      const attributeValue = "ALL";

      const formData = new FormData();
      formData.append(`attributes[${attributeName}]`, attributeValue);

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        console.log('Cart updated successfully:', data);
      })
      .catch(error => {
        console.error('Error updating cart:', error);
      });
    }, 2000);

    setTimeout(function() {
      let campaignMessages = document.querySelectorAll(".BFCM25_holidaysavings");
      let campaignPrices = document.querySelectorAll(".BFCM25_holidaypricing");

      if (campaignMessages) {
        campaignMessages.forEach(campaignMessage => {
          campaignMessage.style.display = 'block';
        });
      }
      if (campaignPrices) {
        campaignPrices.forEach(campaignPrice => {
          campaignPrice.style.display = 'block';
        });
      }

      localStorage.setItem('BFCM25_holidaysavings', campaignIdFromUrl);

      const attributeName = "BFCM25_holidaysavings";
      const attributeValue = "ALL";

      const formData = new FormData();
      formData.append(`attributes[${attributeName}]`, attributeValue);

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        console.log('Cart updated successfully:', data);
      })
      .catch(error => {
        console.error('Error updating cart:', error);
      });
    }, 3000);
  }
  
});

document.addEventListener("facet:update",function(event) {
  
  setTimeout(function(){
    const productCardColors = document.querySelectorAll('.product-card .product-card__colors label');
  
    if (productCardColors) {
        productCardColors.forEach(productCardColor => {
        productCardColor.addEventListener('click', function() {
          let quickViewColor = this.getAttribute('on-click');
          let quickViewColorName = this.querySelector('span').innerText;
          document.querySelector('[for="' + quickViewColor + '"]').click();
          let quickViewProductCard = this.closest('.product-card');
          quickViewProductCard.querySelector('.product-card__quick-view--mobile-color').innerText = quickViewColorName;
        });
      });
    }
  
    const productCardSizes = document.querySelectorAll('.product-card__quick-view [data-option-name="Size"] label, .product-card__quick-view [data-option-name="Options"] label, .product-card__quick-view [data-option-name="Value"] label');
  
    if (productCardSizes) {
        productCardSizes.forEach(productCardSize => {
        productCardSize.addEventListener('click', function() {
          let quickViewContainer = this.closest('.product-card__quick-view');
          setTimeout(function(){
            let variant_id = quickViewContainer.querySelector('input[name="id"]').value;
            // console.log(variant_id);
            var data = {
              "id": variant_id,
              "quantity": 1
            }
            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: data,
              dataType: 'json',
              success: function() { 
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true,  //this code is for prestige theme, is to refresh the cart
                  detail: {
                    quantity: 1
                  }
                }));
              }   
            }); 
          }, 50);
          document.querySelectorAll('.product-card__quick-view').forEach(function (elem) {
            elem.classList.remove('active');
          });
          document.querySelectorAll('.product-card__quick-view .variant-picker').forEach(function (elem) {
            elem.classList.remove('active');
          });
          document.documentElement.classList.remove('lock');
        });
      });
    }

    const productCardQuickDesktopButtons = document.querySelectorAll('.product-card__quick-view .product-card__quick-view--add-desktop');

    if (productCardQuickDesktopButtons) {
        productCardQuickDesktopButtons.forEach(productCardQuickDesktopButton => {
        productCardQuickDesktopButton.addEventListener('click', function() {
          let quickViewContainer = this.closest('.product-card__quick-view');
          document.querySelectorAll('.product-card__quick-view .variant-picker').forEach(function (elem) {
            elem.classList.remove('active');
          });
          quickViewContainer.querySelector('.variant-picker').classList.add('active');
        });
      });
    }
  
    const productCardQuickMobileButtons = document.querySelectorAll('.product-card__quick-view--add-mobile');
  
    if (productCardQuickMobileButtons) {
        productCardQuickMobileButtons.forEach(productCardQuickMobileButton => {
        productCardQuickMobileButton.addEventListener('click', function() {
          let quickViewProductCard = this.closest('.product-card');
          document.querySelectorAll('.product-card__quick-view').forEach(function (elem) {
            elem.classList.remove('active');
          });
          quickViewProductCard.querySelector('.product-card__quick-view').classList.add('active');
          document.documentElement.classList.add('lock');
        });
      });
    }
  
    const productCardQuickOverlays = document.querySelectorAll('.product-card__quick-view-overlay');
  
    if (productCardQuickOverlays) {
        productCardQuickOverlays.forEach(productCardQuickOverlay => {
        productCardQuickOverlay.addEventListener('click', function() {
          let quickViewProductCard = this.closest('.product-card');
          quickViewProductCard.querySelector('.product-card__quick-view').classList.remove('active');
          document.documentElement.classList.remove('lock');
        });
      });
    }

    const productCardQuickCloseButtons = document.querySelectorAll('.product-card__quick-view__close-button');

    if (productCardQuickCloseButtons) {
        productCardQuickCloseButtons.forEach(productCardQuickCloseButton => {
        productCardQuickCloseButton.addEventListener('click', function() {
          let quickViewProductCard = this.closest('.product-card');
          quickViewProductCard.querySelector('.product-card__quick-view').classList.remove('active');
          document.documentElement.classList.remove('lock');
        });
      });
    }
  }, 1000);
  
});

document.addEventListener('variant:change', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  if (variant.available) {
    document.querySelector('.sold-out-label').style.display = "none";
  } else {
    document.querySelector('.sold-out-label').style.display = "block";
  }

  let selectedColor = variant.option1.replace(/\s/g, "").toLowerCase();
  let selectedSize = variant.option2.replace(/\s/g, "").toLowerCase();
  document.querySelectorAll('[data-block-type="product-siblings"] a').forEach(link => {
    var current = link.href.split('?')[0];
    var varId = link.getAttribute('data-size-color-' + selectedSize + '-' + selectedColor);
    link.href = current + '?variant=' + varId + '&Size=' + selectedSize + '&Color=' + selectedColor;
  });

  if (variant.id == 39888071229525) {
    console.log('true');
    let laundryVariantPriceList = document.querySelector('price-list[variant-price="39888071229525"]');
    if (laundryVariantPriceList) {
      laundryVariantPriceList.style.display = 'flex';
    }
  } else {
    let laundryVariantPriceList = document.querySelector('price-list[variant-price="39888071229525"]');
    if (laundryVariantPriceList) {
      laundryVariantPriceList.style.display = 'none';
    }
  }
});


const urlParams = new URLSearchParams(window.location.search);
const campaignIdFromUrl = urlParams.get('BFCM25_holidaysavings');
console.log(urlParams);

if (campaignIdFromUrl == 'ALL') {
  localStorage.setItem('BFCM25_holidaysavings', campaignIdFromUrl);

  const attributeName = "BFCM25_holidaysavings";
  const attributeValue = "ALL";

  const formData = new FormData();
  formData.append(`attributes[${attributeName}]`, attributeValue);

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    console.log('Cart updated successfully:', data);
  })
  .catch(error => {
    console.error('Error updating cart:', error);
  });
}